class HeroBannerSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.waitForSwiperAndInitialize();
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    waitForSwiperAndInitialize() {
        if (typeof Swiper !== 'undefined') {
            this.initializeSwiper();
        } else {
            const checkSwiper = () => {
                if (typeof Swiper !== 'undefined') {
                    this.initializeSwiper();
                } else {
                    setTimeout(checkSwiper, 100);
                }
            };
            checkSwiper();
        }
    }

    initializeSwiper() {
        const swiperElement = this.querySelector('.hero-banner-swiper');
        if (!swiperElement) return;

        // Get settings from data attributes
        const enableAutoplay = this.dataset.enableAutoplay === 'true';
        const autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;
        const showNavigation = this.dataset.showNavigation === 'true';
        const showPagination = this.dataset.showPagination === 'true';

        const swiperConfig = {
            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            touchRatio: 1,
            touchAngle: 45,
            grabCursor: true,

            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            }
        };

        if (enableAutoplay) {
            swiperConfig.autoplay = {
                delay: autoplayDelay,
                disableOnInteraction: false,
            };
        }

        if (showNavigation) {
            swiperConfig.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        }

        if (showPagination) {
            swiperConfig.pagination = {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            };
        }

        if (enableAutoplay) {
            swiperConfig.on = {
                init: function () {
                    const swiperEl = this.el;
                    swiperEl.addEventListener('mouseenter', () => {
                        this.autoplay.stop();
                    });
                    swiperEl.addEventListener('mouseleave', () => {
                        this.autoplay.start();
                    });
                }
            };
        }

        this.swiper = new Swiper(swiperElement, swiperConfig);
    }
}

if (!customElements.get('hero-banner-slider')) {
    customElements.define('hero-banner-slider', HeroBannerSlider);
}